module.exports = __webpack_public_path__ + "static/media/alycore02.c344c10a.jpeg";